import React from 'react';

import Message from 'components/Message';
import { Column, ColumnLayout, Title } from 'features/App';
import ClasstivitySchedulerForm from './ClasstivitySchedulerForm';
import ClasstivitySchedulerTable from './ClasstivitySchedulerTable';
import messages from '../Schedules.messages';

const ClasstivityScheduler = () => {
  return (
    <ColumnLayout>
      <Column>
        <Message as={Title} message={messages.board.title} />
        <ClasstivitySchedulerForm />
        <ClasstivitySchedulerTable />
      </Column>
    </ColumnLayout>
  );
};

export default ClasstivityScheduler;
